<vdw-bit-pattern-editor (bitPatternChange)="onBitPatternChanged($event)" [bitPattern]="value" [showHexValue]="false" [disabled]="disabled"></vdw-bit-pattern-editor>
